import { MediaDto } from "./MediaDto.js";
import { UserDto } from "./UserDto.js";
import { ReportRemarkDto } from "./ReportRemarkDto.js";
import { ReportEditDto } from "./ReportEditDto.js";
import { RespondingAgencyDto } from "./RespondingAgencyDto.js";
import { ReportSubcategoryDto } from "./ReportSubcategoryDto.js";
import { ReportCategoryDto } from "./ReportCategoryDto.js";
export class ReportDto {
    id;
    subject;
    summary;
    isPrivate;
    severityLevel;
    createdAt;
    updatedAt;
    deletedAt;
    categories;
    subCategories;
    respondingAgencies;
    edits;
    media;
    remarks;
    createdById;
    createdBy;
    reportedBy;
    contactRefrences = [];
    get images() {
        return this.media.filter((m) => m.type === "Image");
    }
    get videos() {
        return this.media.filter((m) => m.type === "Video");
    }
    get documents() {
        return this.media.filter((m) => m.type === "Document");
    }
    constructor(obj) {
        Object.assign(this, obj);
    }
    static create(obj) {
        return new ReportDto(obj);
    }
}
//# sourceMappingURL=ReportDto.js.map